// extracted by mini-css-extract-plugin
export default {"errorNote":"styles_errorNote__PQw10"};